export const DEFAULT_LINK_ERROR =
  'This referral fee link is invalid. Please request a new link.';

/** Pulls the backend ValidationException message out of a rejected Service call. */
export const getApiErrorMessage = (e: any, fallback: string): string =>
  e?.error?.response?.data?.error?.message || fallback;
